export default function(amount, locale, currencyCode) {
  if (!locale || !currencyCode || locale === "undefined-undefined") {
    return "";
  }
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency: currencyCode
  }).format(amount);
}
